import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, CircularProgress } from '@mui/material';

export const ConfirmDialog = ({ 
  open, 
  title, 
  message, 
  onConfirm, 
  onCancel, 
  loading = false
}) => {
  const theme = localStorage.getItem('theme') || 'light';
  return (
    <Dialog open={open} onClose={onCancel}
    >
      <DialogTitle
      className={` ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`}>{title}</DialogTitle>
      <DialogContent
      className={` ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`}>
        <DialogContentText
      className={` ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions
      className={` ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`}>
        <Button onClick={onCancel} color="primary" disabled={loading}>
          Cancelar
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained" 
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};